import { useTranslation } from 'react-i18next';
import { Page } from './ui';

const PhotosAreLoading = () => {
  const { t } = useTranslation('photosPage');

  return (
    <Page>
      <Page.Title>{t('yourPhotosAreLoading')}</Page.Title>
      <Page.Loader />
    </Page>
  );
};

export default PhotosAreLoading;
